// extracted by mini-css-extract-plugin
export var ffContainer = "FormField_ffContainer__IyPxg";
export var ffContainerGtb = "FormField_ffContainerGtb__sd576";
export var ffInput = "FormField_ffInput__Kn7-P";
export var ffInvalid = "FormField_ffInvalid__ljosb";